// extracted by mini-css-extract-plugin
export default {"switchTemplateButtonWrapper":"ButtonSwitchTemplate_switchTemplateButtonWrapper__bSZ0g","button":"ButtonSwitchTemplate_button__bpxuP"};